module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "Basic-Text-Frame",
    attrs: {
      "id": "_idContainer002"
    }
  }, [_c('p', {
    staticClass: "drop ParaOverride-1"
  }, [_c('span'), _c('span', {
    staticClass: "com-rorohiko-pagestaker-style"
  }, [_vm._v("iv")])]), _vm._v(" "), _c('div', {
    staticClass: "auth"
  }, [_c('img', {
    staticClass: "i100",
    attrs: {
      "alt": "author photo",
      "src": "image/1.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "drop"
  }, [_c('span', {
    staticClass: "_idGenDropcap-2"
  }, [_vm._v("D")]), _vm._v("eborah Blake is the author of over a dozen books on modern Witchcraft, including "), _c('span', {
    staticClass: "ital"
  }, [_vm._v("The Little Book of Cat Magic")]), _vm._v(" and "), _c('span', {
    staticClass: "ital"
  }, [_vm._v("Everyday Witchcraft")]), _vm._v(", as well as the acclaimed "), _c('span', {
    staticClass: "ital"
  }, [_vm._v("Everyday Witch Tarot")]), _vm._v(" and "), _c('span', {
    staticClass: "ital"
  }, [_vm._v("Everyday Witch Oracle")]), _vm._v(" decks. She has also written three paranormal romance and urban fantasy series for Berkley, and her new cozy mystery series launches with "), _c('span', {
    staticClass: "ital"
  }, [_vm._v("Furbidden Fatality")]), _vm._v(" in 2021. Deborah lives in a 130-year-old farmhouse in upstate New York with numerous cats who supervise all her activities, both magical and mundane. She can be found at: DeborahBlakeAuthor.com")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8c95992a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/About.vue
// module id = 57
// module chunks = 0